import React, { useState } from 'react';
import accountsModel from 'models/accounts-model';
import { COLUMN_ORDER_ICON_ENUM } from 'util/data/constants';

const AccountTableHeader = () => {
    const [dateOrder, setDateOrder] = useState(1);
    const [dateOrderIcon, setDateOrderIcon] = useState(COLUMN_ORDER_ICON_ENUM[1]);
    const [accountNameOrder, setAccountNameOrder] = useState(0);
    const [accountNameOrderIcon, setAccountNameOrderIcon] = useState(COLUMN_ORDER_ICON_ENUM[0]);

    const handleAccountNameOrderClick = () => {
        if (accountNameOrder === 0) {
            setAccountNameOrder(1);
            setAccountNameOrderIcon(COLUMN_ORDER_ICON_ENUM[1]);
            accountsModel.sortAccounts('name', 0); 
        } else if (accountNameOrder === 1) {
            setAccountNameOrder(2);
            setAccountNameOrderIcon(COLUMN_ORDER_ICON_ENUM[2]);
            accountsModel.sortAccounts('name', 1);
        } else if (accountNameOrder === 2) {
            setAccountNameOrder(0);
            setAccountNameOrderIcon(COLUMN_ORDER_ICON_ENUM[0]);
            accountsModel.sortAccounts('name', 2);
        }
        setDateOrder(0);
        setDateOrderIcon(COLUMN_ORDER_ICON_ENUM[0]);    
    };


    const handleDateOrderClick = () => {
        if (dateOrder === 1) {
            setDateOrder(2);
            setDateOrderIcon(COLUMN_ORDER_ICON_ENUM[2]);
            accountsModel.sortAccounts('createdDateTime', 1);
        } else if (dateOrder === 2) {
            setDateOrder(0);
            setDateOrderIcon(COLUMN_ORDER_ICON_ENUM[0]);
            accountsModel.sortAccounts('createdDateTime', 2);
        } else if (dateOrder === 0) {
            setDateOrder(1);
            setDateOrderIcon(COLUMN_ORDER_ICON_ENUM[1]);
            accountsModel.sortAccounts('createdDateTime', 0);
        }
        setAccountNameOrder(0);
        setAccountNameOrderIcon(COLUMN_ORDER_ICON_ENUM[0]);    
    };

    return (
        <> 
            <td>
                <div className="flex-box">
                    <div className="cell-label">
                        Account Name
                    </div>
                    <button className="order-button" onClick={handleAccountNameOrderClick}>
                        {accountNameOrderIcon}
                    </button>
                </div>                     
            </td>
            <td>Account ID</td>
            <td>Status</td>
            <td>Usage (GB)</td>
            <td>Seats</td>
            <td>Version</td>
            <td>Project Count</td>
            <td>
                <div className="flex-box">
                    <div className="cell-label">
                        Created
                    </div>
                    <button className="order-button" onClick={handleDateOrderClick}>
                        {dateOrderIcon}
                    </button>
                </div>
            </td>
            <td>Promapper Account</td>
        </>
    );
};
 
const AccountTableHeaderElement = (props) => React.createElement(AccountTableHeader, props, null);

export default AccountTableHeaderElement;
